import product from "./product";

export default {
    product,

    noAvailableItems: "没有可供订购的产品。"
}